import { Button } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { useStepState } from '../../../../components/step/useStepState';
import { SectionTitle } from '../../../../components/text';
import { PathsLayouts } from '../../../../config/routes';
import { TranslationsKeys } from '../../../../locales/translations';
import { updateAcademicOfferCurrentStep } from '../api';
import { useAcademicOfferWizard } from '../context/AcademicOfferWizardContext';
import { CeAcademicOfferStepEnum } from '../types';

export function AcademicOfferSummary() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { prevStep } = useStepState();
  const { ceAcademicOfferId } = useAcademicOfferWizard();
  const history = useHistory();

  const handleBack = async () => {
    if (!ceAcademicOfferId) {
      return;
    }
    await updateAcademicOfferCurrentStep(
      ceAcademicOfferId,
      CeAcademicOfferStepEnum.Schedule,
    );
    prevStep();
  };

  const handleConfirm = () => {
    history.push(`${PathsLayouts.continuousEducation}/academic-offers`);
  };

  return (
    <>
      <SectionTitle text={t('wizard.steps.resumen')} />
      <div className="py-5 text-center text-muted">
        {t('wizard.placeholder')}
      </div>
      <Row>
        <Col xs={12} md={6} lg={4} className="offset-md-6 offset-lg-8">
          <Row>
            <Col>
              <Button
                text={t('wizard.back')}
                outlined
                fullwidth
                onClick={handleBack}
              />
            </Col>
            <Col>
              <Button
                text={t('wizard.confirm')}
                fullwidth
                onClick={handleConfirm}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
